const APP_CONFIG = {
  MIXPANEL_KEY:
    process.env.REACT_APP_MIXPANEL || "41b84c964498d9147d60b2cac8a31c17",
  CLIENT_ENV: process.env.REACT_APP_CLIENT_ENV || "OZE_DEV",
};

export default APP_CONFIG;
